import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { EstimatePaymentInner } from './parts';

import { JSX } from 'react';
import styles from './estimatePayment.module.scss';

export type EstimatePaymentProps =
  SliceComponentProps<Content.EstimatePaymentSlice>;

const EstimatePayment = ({ slice }: EstimatePaymentProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={styles.section}
    >
      <EstimatePaymentInner slice={slice} />
    </section>
  );
};

export default EstimatePayment;
